<script setup lang="ts">
import type { LegacyClassBinding } from './types'

defineProps<{
  id: string
  visible: boolean
  barClass: LegacyClassBinding
  message: string
}>()
</script>

<template>
  <div v-show="visible" class="progress" :id="id">
    <div
      class="progress-bar progress-bar-striped"
      :class="barClass"
      role="progressbar"
      aria-valuenow="40"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width:100%;"
    >
      <span>{{ message }}</span>
    </div>
  </div>
</template>
